var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailiconBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2822 0C14.3997 0 15.4747 0.441667 16.2655 1.23417C17.0572 2.025 17.4997 3.09167 17.4997 4.20833V10.7917C17.4997 13.1167 15.608 15 13.2822 15H5.04967C2.72384 15 0.833008 13.1167 0.833008 10.7917V4.20833C0.833008 1.88333 2.71551 0 5.04967 0H13.2822ZM14.6079 5.44987L14.6746 5.3832C14.8738 5.14153 14.8738 4.79153 14.6654 4.54987C14.5496 4.4257 14.3904 4.34987 14.2246 4.3332C14.0496 4.32403 13.8829 4.3832 13.7571 4.49987L9.99962 7.49987C9.51628 7.9007 8.82378 7.9007 8.33295 7.49987L4.58295 4.49987C4.32378 4.3082 3.96545 4.3332 3.74962 4.5582C3.52462 4.7832 3.49962 5.14153 3.69045 5.39153L3.79962 5.49987L7.59128 8.4582C8.05795 8.82487 8.62378 9.02487 9.21628 9.02487C9.80712 9.02487 10.3829 8.82487 10.8488 8.4582L14.6079 5.44987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailiconBtn);
export default __webpack_public_path__ + "static/media/mailicon-btn.fee4d3abd6801b82ae68013855ae8b3f.svg";
export { ForwardRef as ReactComponent };